import React from 'react';
import { Link } from "gatsby";
import Breadcrumb from "§/src/components/atoms/breadcrumb/breadcrumb"

/**
 * Internal dependencies.
 */
import MainNav from './navs/main-nav';
import './_header.scss';

// Language
import { useTranslation } from 'react-i18next';

const productIndex = 'Products_' + process.env.GATSBY_SITE_LANG + '_dev'
const newsIndex = 'NewsEvents_' + process.env.GATSBY_SITE_LANG + '_dev'
const applicationsIndex = 'Applications_' + process.env.GATSBY_SITE_LANG + '_dev'
const caseHistoriesIndex = 'Case_Histories_' + process.env.GATSBY_SITE_LANG + '_dev'

// import DevGrid from '§/src/components/_dev/grid';

const Header = ( { data, className, breadcrumbs, lang, langReplace } ) => {

	const { t } = useTranslation();

	// const { getHeader: { siteTitle, siteTagLine } } = data.wp;
	const siteTitle = '';
	const siteTagLine = '';
	const headerMenu = data.headerMenu;
	const headerCatMenu = data.headerCatMenu;
	const langMenu = data.langMenu;
	const topMenu = data.topMenu;
	const socialMenu = data.socialMenu;
	const general = data.wp.generalSettings;
	const categories = data.categories;


	return (
		<React.Fragment>
			<header id="main-header" className={className}>
				<MainNav lang={lang} langMenu={ langMenu } general={ general } title={ siteTitle } tagline={ siteTagLine } rawData={data} />
			</header>
		</React.Fragment>
	);
};

export { Header };
